module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/inner-space/main-scene/main-right/main-right.component.css
// module id = ./src/app/inner-space/main-scene/main-right/main-right.component.css
// module chunks = main